import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const MegaphoneIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M16.7129 1.13794C17.5372 0.49215 18.798 0.880336 19.0811 1.93579L22.5059 14.719C22.8073 15.845 21.7653 16.8694 20.6445 16.5491L16.1533 15.2639L13.0684 16.0911L14.333 18.8733C14.9805 20.2969 14.426 21.9794 13.0586 22.7385L13.0078 22.7668C11.4525 23.6303 9.49086 22.9583 8.79199 21.3225L7.19727 17.5881C4.63967 17.8397 2.20176 16.2144 1.51465 13.6506L1.47461 13.5032C0.688683 10.5692 2.43032 7.55397 5.36426 6.76782L13.3066 4.63892L16.5537 1.28052L16.7129 1.13794ZM9.17773 17.1331L10.6318 20.5364C10.8648 21.0816 11.5187 21.3056 12.0371 21.0178L12.0889 20.9895C12.5444 20.7363 12.7285 20.1749 12.5127 19.7004L11.1094 16.6155L9.17773 17.1331ZM5.88184 8.69946C4.01475 9.19975 2.90702 11.1185 3.40723 12.9856L3.44629 13.1331C3.92491 14.9186 5.76022 15.9783 7.5459 15.5002L14.9375 13.5198L13.126 6.75806L5.88184 8.69946ZM14.9453 5.82056L16.9824 13.4211L20.3457 14.3831L17.3779 3.30591L14.9453 5.82056Z'
        fill={color}
      />
    </svg>
  )
})
